import { __, curry } from 'ramda';

export const PERCENTS_TO_CHANGE_TITLE_POSITION = 20;

const HIGH_PROGRESS_THRESHOLD = 90;

const BOUNDARIED_MIN_DEFAULT = 0;
const BOUNDARIED_MAX_DEFAULT = 100;

const BOUNDARIED_MIN_SHOW_VALUE = 1;
const BOUNDARIED_MAX_SHOW_VALUE = 100;

const boundaryRounding = curry(
  (value: number, boundaries: { min: number; max: number }): number => {
    if (value < boundaries.min) return boundaries.min;
    if (value > boundaries.max) return boundaries.max;
    return value;
  }
);

const round = (value: number, roundTo: number) => {
  if (value > HIGH_PROGRESS_THRESHOLD) {
    return Math.floor(value * roundTo) / roundTo;
  }
  return Math.round(value * roundTo) / roundTo;
};

const calculatePercent = (
  start: number,
  end: number,
  curr: number,
  params: {
    roundTo: number;
  }
) => {
  const res = start === end ? 100 : ((curr - start) / (end - start)) * 100;
  return round(res, params.roundTo);
};

export const boundariedValueForShowValue = boundaryRounding(__, {
  min: BOUNDARIED_MIN_SHOW_VALUE,
  max: BOUNDARIED_MAX_SHOW_VALUE,
});

export const boundariedValueDefault = boundaryRounding(__, {
  min: BOUNDARIED_MIN_DEFAULT,
  max: BOUNDARIED_MAX_DEFAULT,
});

export const calculateProgress = (value: number, min: number, max: number) => {
  if (!value) return 0;
  if (!max || value >= max) return 100;
  return calculatePercent(min, max, value, { roundTo: 1 });
};
